<template>
    <page-container2 :title="formTitle" :useCard="false" showPageBack>
        <template v-slot:buttons >
            <el-button type="success" size="mini" @click="loadAfterSale" :disabled="!aftersale.id">刷新</el-button>
        </template>
        <permission-container  v-loading="loading" showTip :permissionId="permissionId">
            <el-form ref="orderForm" :model="aftersale" v-loading="loading" status-icon :inline-message="true" label-width="0px" size="mini">
                <el-card id="printInfo">
                    <div class="panel-info">
                        <div class="panel-info-name">
                            <span class="panel-info-label">基础信息</span>
                        </div>
                        <div class="panel-table">
                            <el-row class="panel-table-row">
                                <el-col :span="4"><span class="panel-table-col col-label required">客户：</span></el-col>
                                <el-col :span="4">
                                    <div class="panel-table-col col-input">{{ aftersale.customerName }}
                                    </div>
                                </el-col>
                                <el-col :span="4"><span class="panel-table-col col-label">客户编号：</span></el-col>
                                <el-col :span="4">
                                    <div class="panel-table-col col-input">
                                        <el-form-item prop="customerCode">
                                            <div>{{ aftersale.customerCode }}</div>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="4"><span class="panel-table-col col-label required">退货单号：</span></el-col>
                                <el-col :span="4">
                                    <div class="panel-table-col col-input">
                                        {{aftersale.aftersaleCode}}
                                    </div>
                                </el-col>
                            </el-row>

                            <el-row class="panel-table-row">
                                <el-col :span="4"><span class="panel-table-col col-label required">售后类型：</span></el-col>
                                <el-col :span="4">
                                    <div class="panel-table-col col-input">
                                        {{aftersale.type==1?'退货':'换货'}}
                                    </div>
                                </el-col>
                                <el-col :span="4"><span class="panel-table-col col-label required">退货日期：</span></el-col>
                                <el-col :span="4">
                                    <div class="panel-table-col col-input">
                                        <date-render :value="aftersale.returnDate"></date-render>
                                    </div>
                                </el-col>
                                <el-col :span="4"><span class="panel-table-col col-label">关联订单送货单号：</span></el-col>
                                <el-col :span="4">
                                    <div class="panel-table-col col-input">
                                        {{ aftersale.orderDeliveryNumber }}
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row class="panel-table-row">
                                <el-col :span="4"><span class="panel-table-col col-label">备注：</span></el-col>
                                <el-col :span="20">
                                    <div class="panel-table-col col-input">
                                        {{aftersale.remark}}
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        
                    </div>

                    <div class="panel-info">
                        <div class="panel-info-name">
                            <span class="panel-info-label">产品信息</span>
                        </div>
                        <div class="panel-table">
                            <el-row class="panel-table-row">
                                <el-col :span="6"><span class="panel-table-col col-header required">货物名称</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header required">规格</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header required">件数</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header required">数量</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header required">单位</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header required">单价</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header required">金额(RMB)</span></el-col>
                                <el-col :span="6"><span class="panel-table-col col-header">备注</span></el-col>
                            </el-row>
                            <template v-for="(product, index) in productList">
                                <el-row class="panel-table-row">
                                    <el-col :span="6">
                                        <span class="panel-table-col col-input" v-if="product.productId">
                                            {{product.productName}}（{{product.productCode}}）
                                        </span>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input">
                                            {{product.spec}}
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input">
                                            {{product.num}}
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input">
                                            {{product.unitNum}}
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input">
                                            {{product.unit}}
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input">
                                            {{product.unitPrice}}
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input">
                                            <money-render :value="product.amount" :precision="2"/>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="panel-table-col col-input">
                                            {{product.remark}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </template>
                        </div>
                        <div class="panel-info-tail">
                            <div class="total-price">合计：
                                <money-render :value="productTotalAmount"></money-render>
                            </div>
                        </div>
                    </div>
                </el-card>
            </el-form>
        </permission-container>
        
    </page-container2>
</template>

<script>
import List from "@/components/table/List";

export default {
    name: "AfterSaleDetail",
    data()
    {
        return {
            loading: false,
            formTitle: '售后单详情',
            permissionId: 'Erp.AfterSale.Detail',
            aftersale: {
                id: null,
                aftersaleCode: '',
                customerId: null,
                customerCode: '',
                customerName: '',
                returnDate : null,
                type : null,
                orderDeliveryNumber : '',
                remark: '',
                state: null,
                logoUrl: ''
            },
            productList:[],
            emptyLineList:[]
        }
    },
    mounted()
    {
        return Fx.Promise.
        then(()=>
        {
            if(this.$route.query && this.$route.query.id)
            {
                this.aftersale.id = this.$route.query.id;
                return this.loadAfterSale();
            }
        })
    },
    methods:
    {
        loadAfterSale()
        {
            this.loading = true;
            return Fx.Http.post("/aftersale/get", {id: this.aftersale.id}).
            then((resp)=>
            {
                console.log('aftersale:', resp);
                if(resp.isSuccess())
                {
                    this.aftersale = Fx.mergeDeep(this.aftersale, resp.getData());
                    this.productList = resp.getData('productList');
                }
            }).
            then(()=>
            {
                this.loading = false;
            });
        },
        
    },
    computed:
    {
        productTotalAmount()
        {
            let amount = 0.00;
            this.productList&&this.productList.map(product=>amount+=(isNaN(product.amount)? 0: product.amount));
            return amount;
        },
        productTotalNum()
        {
            let num = 0;
            this.productList&&this.productList.map(product=>num+=(isNaN(product.num)? 0: product.num));
            return num;
        
        },
        productTotalUnitNum()
        {
            let unitNum = 0;
            this.productList&&this.productList.map(product=>unitNum+=(isNaN(product.unitNum)? 0: product.unitNum));
            return unitNum;
        }
    }
}
</script>

<style scoped lang="scss">
@import "~@/styles/common.scss";
.order-panel
{
    flex:1;
    max-width: calc(100% - 300px);
}
.order-state-caption
{
    padding: 5px 20px;
    background-color: #ff8e02;
    color: white;
    font-size: 18px;
}
.exchange-rate
{
    color: #333333;
    font-size: 12px;
    margin-bottom: 3px;
}
.total-price
{
    font-size: 14px;
    font-weight: 700;
}
.dialog-message
{
    color: rgb(255, 153, 0);
    margin: 0 0 10px 31px;
}
.demo-order
{
    padding: 1px 5px;
    margin-left: 3px;
    border-radius: 3px;
    color: #ffffff;
    background-color: #ff8e02;
}

</style>



// WEBPACK FOOTER //
// src/modules/erp/pages/aftersale/Detail.vue